// extracted by mini-css-extract-plugin
export default {"tooltip":"Dropdown_tooltip__uavSB"};